export const AUTO_ROUTE_ENTRIES = [
  {
    id: "sandbox",
    path: "sandbox",
    title: "Component Sandbox",
    description: "Interactive isolated component testing harness.",
  },
  // {
  //   id: "demos",
  //   path: "demos",
  //   title: "Feature Demos",
  //   description: "Full-feature interactive application demos.",
  // },
] as const;

export type AutoRouteId = (typeof AUTO_ROUTE_ENTRIES)[number]["id"];

export interface AutoRouteEntry {
  id: AutoRouteId;
  path: string;
  title: string;
  description?: string;
}
